import React, { useMemo } from "react";
import { formatMoney } from "../../../../../features/utils/formatMoney";

function PricingBreakdown({ data }) {
  const travellerLib = {
    ADT: "Adult",
    CHD: "Child",
    CNN: "Child",
    INF: "Infant",
    INS: "Infant",
  };

  const passengerPrice = Array.isArray(data?.passengerPrice)
    ? data.passengerPrice
    : [];

  const travellers = data?.flightBooking?.travelers || [];

  // console.log({ data });

  const rows = useMemo(() => {
    return passengerPrice.map((p, idx) => {
      let count = 1;
      const passengerIds = data?.passengerIds || [];

      const travellerTypePassegers = travellers?.filter(
        (item) =>
          item?.travelerType === p?.travelerType &&
          passengerIds?.includes(item?.id),
      );
      count = Math.max(count, travellerTypePassegers?.length);

      const breakdown = Array.isArray(p?.breakDown) ? p.breakDown : [];
      const subtotal =
        breakdown.reduce((sum, item) => sum + (Number(item?.amount) || 0), 0) *
        count;

      const travellerTypeLabel =
        travellerLib[p?.travelerType] || p?.travelerType || "Adult";
      return { key: idx, travellerTypeLabel, breakdown, subtotal, count };
    });
  }, [passengerPrice]);

  const serviceFee = (data?.intraverseFee ?? 0) || 0;

  return (
    <div className="w-full flex flex-col">
      {rows.map((row) => (
        <div key={row.key} className="mb-4 last:mb-0">
          <div className="flex justify-between items-center mb-2">
            <span className="font-medium">
              {row.count} x {row.travellerTypeLabel}
            </span>
            <span className="font-semibold text-gray-900">
              {formatMoney(row.subtotal)}
            </span>
          </div>

          {/* Passenger-specific breakdown (indented) */}
          <div className="pl-4 space-y-1">
            {row.breakdown.map((b, i) => (
              <div className="flex justify-between" key={i}>
                <span className="text-gray-500">{b?.name}</span>
                <span className="text-gray-700">
                  {formatMoney(Number(b?.amount) || 0)}
                </span>
              </div>
            ))}
          </div>
        </div>
      ))}

      {/* Service fee (top-level) */}
      <div className="flex justify-between items-center mt-4 mb-4">
        <span className="font-medium">
          {data?.passengerIds?.length || 1} x Service fee
        </span>
        <span className="font-semibold text-gray-900">
          {formatMoney(serviceFee)}
        </span>
      </div>

      <hr className="border-gray-300 mb-3" />

      {/* Totals (top-level) */}
      <div className="flex justify-between items-center mb-1">
        <span className="font-semibold text-gray-900">Total</span>
        <span className="font-semibold text-gray-900">
          {formatMoney(data?.payable || 0)}
        </span>
      </div>

      <div className="text-right mt-1 text-primary1 font-semibold text-lg">
        - {formatMoney(data?.payable || 0)}
      </div>
    </div>
  );
}

export default PricingBreakdown;
